import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export interface DetailsListItemProps extends PropsWithChildren {
  label?: string;
}

const DetailsListItem: FC<DetailsListItemProps> = ({ label, children }) => {
  const { t, checkKey } = useTranslation();
  const labelText = label && checkKey(label) ? t(label) : label;

  return (
    <li className="grid grid-cols-8 gap-2">
      <div className="block col-span-3 m-0 text-xs font-semibold text-text-base-secondary wrap-break-word">
        {labelText}
      </div>
      <div className="col-span-5 text-xs text-text-base-secondary wrap-break-word">{children}</div>
    </li>
  );
};

export const DetailsList: FC<PropsWithChildren<{ className?: string }>> & {
  Item: typeof DetailsListItem;
} = ({ children, className }) => <ul className={clsx("flex flex-col gap-3 list-none", className)}>{children}</ul>;

DetailsList.Item = DetailsListItem;
